import {Component, OnInit, ViewEncapsulation} from '@angular/core';

import {Breadcrumb} from './breadcrumb';
import {BreadcrumbService} from './breadcrumb.service';


@Component({
  selector: 'aqx-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BreadcrumbComponent implements OnInit {
  breadcrumbs$;

  constructor(private breadcrumbService: BreadcrumbService) {
    this.breadcrumbs$ = breadcrumbService.getBreadcrumbs();
  }

  ngOnInit() {
  }
}
